import {
  ExpensesCustomizationConfigResourceTypeEnum,
  ExpensesEntitiesExpensableResourceTypeEnum,
} from 'generated/resources/graphql'
import { z } from 'zod'

import i18n from 'modules/core/lib/i18n'

import {
  CustomizationField,
  fieldEnabled as isEnabled,
  isMandatory,
} from 'modules/expenses/hooks/useExpensesCustomization'
import { BudgetOption } from 'modules/finance/hooks/useBudgets'

const defaultRequiredMessage = () => ({
  message: i18n.t('expenses_v2.forms.errors.required'),
})

export interface FormContext {
  customizationFields: CustomizationField[]
  budgetOptions: BudgetOption[]
  resourceType: ExpensesCustomizationConfigResourceTypeEnum
}

export const BudgetSchema = ({ customizationFields, budgetOptions, resourceType }: FormContext) => {
  return z.object({
    budgetId: z
      .number()
      .nullable()
      .refine((budgetId) => {
        if (!shouldShowBlock(budgetOptions, customizationFields, resourceType)) {
          return true
        }

        return isMandatory('budget_id', resourceType, customizationFields) ? !!budgetId : true
      }, defaultRequiredMessage()),
  })
}

export const shouldShowBlock = (
  budgetOptions: BudgetOption[],
  customizationSettings: CustomizationField[],
  resourceType: ExpensesEntitiesExpensableResourceTypeEnum
) =>
  budgetOptions &&
  budgetOptions.length > 0 &&
  isEnabled(customizationSettings, resourceType, 'budget_id')

export type BudgetSchema = z.infer<ReturnType<typeof BudgetSchema>>
